import type { Invoice } from '@monorepo/shared/schemas/invoices'
import { pdf } from '@react-pdf/renderer'
import { useState } from 'react'
import { InvoicePdfDocument } from '../components/InvoicePdfDocument'

export function useInvoicePdf() {
  const [isGenerating, setIsGenerating] = useState(false)

  async function downloadPdf(invoice: Invoice, tenantName?: string) {
    setIsGenerating(true)
    try {
      const blob = await pdf(
        <InvoicePdfDocument invoice={invoice} tenantName={tenantName} />
      ).toBlob()

      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `${invoice.invoice_number || 'invoice'}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } finally {
      setIsGenerating(false)
    }
  }

  return { downloadPdf, isGenerating }
}
